import React, { useEffect, useState } from "react";
import { IconType } from "react-icons";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { useGetAllFuturePurchaseDataQuery } from "src/services/FuturePurchaseService";
import FuturePurchaseSideBarLayout from "../FuturePurchaseSideBarLayout/FuturePurchaseSideBarLayout";
import { FaNoteSticky } from "react-icons/fa6";

type Props = {};
export const FuturePurchaseTabs: {
  label: string;
  icon: IconType;
  path: string;
  moduleName?: string;
  actionName?: string;
}[] = [
  {
    label: "Followup Notes",
    icon: FaNoteSticky,
    path: `notes`,
  },
];

const FuturePurchaseTicketViewLayout = (props: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split("/")[3];
  const [sidebarListTotalItems, setSidebarListTotalItems] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [limit, setLimit] = useState<number>(10);
  const { page, rowsPerPage } = useSelector(
    (state: RootState) => state.futurePurchase
  );
  const [sidebarList, setSidebarList] = useState<any[]>([]);

  const { data, isLoading, isFetching } = useGetAllFuturePurchaseDataQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: ["mobile"],
    page: page,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setSidebarList(data?.data);
      setSidebarListTotalItems(data?.totalItem || 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);
  return (
    <>
      <SideNavLayout>
        <div className="flex flex-col h-full">
          <div className="flex  gap-2 border-b">
            <div className="">
              <FuturePurchaseSideBarLayout
                hideViewMore={sidebarListTotalItems > limit ? true : false}
                listData={sidebarList}
                searchValue={searchValue}
                onSearch={(value: any) => {
                  setSearchValue(value);
                }}
                loader={isLoading || isFetching}
                onClickViewMore={() => setLimit(limit + 10)}
                onClickChangeRequestView={(FuturePurchaseId) => {
                  navigate(`/future-purchase/${FuturePurchaseId}/notes`);
                }}
              />
            </div>
            <div className="w-full flex flex-col h-[calc(100vh-50px)]">
              {/* FuturePurchaseTabs */}
              {FuturePurchaseTabs?.length && (
                <div className="flex gap-3 items-center bg-white ">
                  {FuturePurchaseTabs?.map((tab: any, index: any) => {
                    return (
                      <div key={index}>
                        <button
                          type="button"
                          onClick={() => navigate(tab.path)}
                          className={`h-full px-4 pb-2 flex gap-2 border-b-[3px] items-center hover:text-primary-main font-medium text-sm transition-all
                      ${
                        currentPath === tab.path?.split("/")[0]
                          ? "text-primary-main  border-primary-main"
                          : "text-gray-700 border-white"
                      }
                      `}
                        >
                          <div className="text-sm">
                            <tab.icon />
                          </div>
                          {tab.label}
                        </button>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="grow overflow-auto bg-gray-50">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </SideNavLayout>
    </>
  );
};

export default FuturePurchaseTicketViewLayout;
